import React from 'react'
import styled from 'styled-components'


const CloseIconWrapper = styled.div`
  display: block;
  width: 15px;
  height: 15px;
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 0;

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (hover: hover) {
    &:hover:before {
      content: '';
      background: ${props => props.hoverColor || 'rgba(0, 173, 239, 0.1)'};
      height: 40px;
      width: 40px;
      border-radius: 50%;
      position: absolute;
      left: -12px;
      top: -12px;
      z-index: -1;
    }
  }

  @media (min-width: 640px) {
    top: 20px;
    right: 32px;
  }
`

const CloseIcon = (props) => (
  <CloseIconWrapper onClick={props.onClick} hoverColor={props.hoverColor}>
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 16 16"
      enableBackground="new 0 0 16 16"
    >  
      <path 
       fill={`${props.color}`}
       d="M9.2,8.5l7.1-7.1c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,
          0L8.5,7.8L1.4,0.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,
          0.7l7.1,7.1l-7.1,7.1c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,
          0.2,0.1,0.4,0.1s0.3,0,0.4-0.1l7.1-7.1l7.1,7.1c0.1,
          0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,
          0-0.7L9.2,8.5z"
      />
    </svg>
  </CloseIconWrapper>
)

export { CloseIcon as default }


// WEBPACK FOOTER //
// ./assets/common/components/icons/CloseIcon.js